var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.575C23.1 2.95 22.2001 3.25 21.15 3.325C22.2001 2.725 22.9501 1.75 23.3251 0.625C22.35 1.225 21.3 1.6 20.175 1.825C19.275 0.85 18 0.25 16.65 0.25C13.95 0.25 11.7 2.425 11.7 5.2C11.7 5.575 11.775 5.95 11.85 6.325C7.72505 6.1 4.12505 4.15 1.65005 1.15C1.20005 1.9 0.975049 2.725 0.975049 3.625C0.975049 5.35 1.87505 6.85 3.15005 7.75C2.32505 7.75 1.57505 7.525 0.900049 7.15V7.225C0.900049 9.625 2.62505 11.575 4.87505 12.025C4.42505 12.1 4.05005 12.175 3.60005 12.175C3.30005 12.175 3.00005 12.175 2.70005 12.1C3.30005 14.05 5.17505 15.475 7.27505 15.55C5.62505 16.9 3.45005 17.65 1.12505 17.65C0.750049 17.65 0.300049 17.65 -0.0749512 17.575C2.17505 18.925 4.80005 19.75 7.57505 19.75C16.65 19.75 21.6 12.25 21.6 5.725C21.6 5.5 21.6 5.275 21.6 5.125C22.5 4.375 23.325 3.55 24 2.575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7e845b7ef48e090fc1abd0c9dc8969c1.svg";
export { ForwardRef as ReactComponent };